module.exports = __webpack_public_path__ + "static/media/add-ball.9a2848de.svg";